import type { WorkflowReviewStatusData } from '@app/shared/types/sf-data'

export type WorkflowOverviewGroup = {
  id: number
  type: 'group'
  name: string
  collapsed?: boolean
  children: Array<WorkflowOverviewItem | WorkflowOverviewGroup>
}

export type WorkflowOverviewItemType = 'account_entry' | 'reconciliation_text'

export type OverviewChecklist = {
  id: number
  name: string
  path: string
}

export type WorkflowOverviewItem = {
  id: number
  name: string
  accountEntryId?: number | null
  contextHrefParam?: string | null
  originalNumber?: string | null
  reviewIndex: number
  type?: WorkflowOverviewItemType
  starred: boolean
  workflowReviewStatusData: WorkflowReviewStatusData | null
  children: undefined
  path: string
  proposalPath: string
}

export type PreparedWorkflowOverviewAccountEntry = {
  id: number
  preparedName: Fuzzysort.Prepared
  preparedNumber: Fuzzysort.Prepared
  preparedOriginalNumber: Fuzzysort.Prepared
}

export type PreparedWorkflowOverviewReconciliationText = {
  id: number
  preparedName: Fuzzysort.Prepared
}

export enum UserTypes {
  INTERNAL_USER = 'internal',
  PULSE_USER = 'pulse',
}

export type UserType = UserTypes.INTERNAL_USER | UserTypes.PULSE_USER

export type StarredChangedEvent = {
  type: 'account_entry' | 'reconciliation_text'
  id: number
  starred: boolean
}

export type ReconIconState = {
  iconClass: string
  colorClass: string
  tooltipKey: string
}

export type IconConfig = {
  iconClass: string
  colorClass: string
  tooltipKey: string
}
